"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _TopLevelEntityTable = _interopRequireDefault(require("../Pinned/PinnedContentSection/Form/TopLevelEntityTable"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function Advanced(_ref) {
  var assignmentData = _ref.assignmentData,
    formikBag = _ref.formikBag,
    index = _ref.index;
  var values = formikBag.values;
  var prefix = "".concat(values.currentPrefix, ".modules.").concat(index);
  var currError = Object.keys(formikBag.errors).some(function (k) {
    return k.startsWith(prefix) && !!formikBag.errors[k];
  });
  var _useState = (0, _react.useState)(currError ? true : false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  (0, _react.useEffect)(function () {
    var thisModuleValues = (0, _get2["default"])(values, prefix, {});
    if (!('visibility' in thisModuleValues) || !('unlockAfter' in thisModuleValues)) {
      formikBag.setFieldValue(prefix, _objectSpread(_objectSpread({}, thisModuleValues), {}, {
        visibility: 'always',
        unlockAfter: 'placeholder'
      }));
    }
  }, [values, prefix]);
  function renderUnlockAfterField(subFormikBag) {
    if (!['disabled', 'hidden'].includes((0, _get2["default"])(values, "".concat(prefix, ".visibility"), false))) {
      return /*#__PURE__*/_react["default"].createElement("span", null);
    }
    var options = [];
    var allModules = (0, _get2["default"])(values, "".concat(values.currentPrefix, ".modules"), []) || [];
    allModules.forEach(function (mod, i) {
      if (i === index) {
        return;
      }
      options.push({
        value: "module_".concat(mod.id),
        label: "Completion of Module ".concat(mod.id)
      });
      mod.surveyHandles.forEach(function (sHandle, j) {
        options.push({
          value: "survey_".concat(sHandle),
          label: "Completion of Module ".concat(mod.id, " Lesson ").concat(j + 1)
        });
      });
    });
    options.unshift({
      value: 'all',
      label: 'Completion of all other modules and lessons'
    });
    options.unshift({
      value: 'allRequired',
      label: 'Completion of all other required modules and lessons'
    });
    options.unshift({
      value: 'entity',
      label: 'Completion of specific part of a lesson'
    });
    options.unshift({
      value: 'placeholder',
      label: '-- Select unlock rule --',
      disabled: true
    });
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "".concat(prefix, ".unlockAfter"),
      component: _cccisdFormik.CccisdSelect,
      label: "Unlock After",
      options: options
    }));
  }
  function renderEntityTable() {
    if (!['disabled', 'hidden'].includes((0, _get2["default"])(values, "".concat(prefix, ".visibility"), false))) {
      return /*#__PURE__*/_react["default"].createElement("span", null);
    }
    if ((0, _get2["default"])(values, "".concat(prefix, ".unlockAfter"), false) !== 'entity') {
      return /*#__PURE__*/_react["default"].createElement("span", null);
    }
    return /*#__PURE__*/_react["default"].createElement(_TopLevelEntityTable["default"], {
      assignmentData: assignmentData,
      isModuleField: true,
      label: "Which specific part of a Lesson?",
      prefix: prefix,
      subFormikBag: formikBag
    });
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].advanced
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-link",
    onClick: function onClick() {
      return setIsExpanded(function (prev) {
        return !prev;
      });
    }
  }, isExpanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null), "Advanced"), isExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-6"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "".concat(prefix, ".visibility"),
    component: _cccisdFormik.CccisdSelect,
    label: "Visibility",
    options: [{
      value: 'always',
      label: 'Always visible and clickable'
    }, {
      value: 'disabled',
      label: 'Disabled until unlocked'
    }, {
      value: 'hidden',
      label: 'Hidden until unlocked'
    }]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-12 col-md-6"
  }, renderUnlockAfterField())), renderEntityTable()));
}
var _default = exports["default"] = Advanced;